import { render, staticRenderFns } from "./modalMillingsFactorConfig.vue?vue&type=template&id=b93e5108&scoped=true&"
import script from "./modalMillingsFactorConfig.vue?vue&type=script&lang=js&"
export * from "./modalMillingsFactorConfig.vue?vue&type=script&lang=js&"
import style0 from "./modalMillingsFactorConfig.vue?vue&type=style&index=0&id=b93e5108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93e5108",
  null
  
)

export default component.exports